import { useContext } from "react";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import {
    ButtonGroup,
    InlineTable,
    InlineTableCell,
    Message,
    ModalContainer,
    PrimaryButton,
    PrimaryText,
    SecondaryButton,
    SecondaryText,
    SSOModal,
} from "./SsoStyledComponents";
import Bullet from "../../../images/cognito_auth/bullet.svg";
import Parser from "html-react-parser";

export interface IUploadMetadataInfoModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm: () => void;
    onCancel: () => void;
}

export const UploadMetadataInfoModal = (props: IUploadMetadataInfoModalProps) => {
    const { open, setOpen, onConfirm, onCancel } = props;
    const { t } = useContext(ApplicationContext);

    const handleClose = () => setOpen(false);

    return (
        <SSOModal onClose={handleClose} open={open} size="small">
            <ModalContainer>
                <Message>
                    <InlineTable>
                        <tbody>
                            <tr>
                                <InlineTableCell>
                                    <img src={Bullet} />
                                </InlineTableCell>
                                <td style={{ verticalAlign: "left", paddingBottom: "1.5rem" }}>
                                    <span>
                                        {Parser(
                                            t("configure_sso_setting.sso_modal.sso_modal_warning_1")
                                        )}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <InlineTableCell>
                                    <img src={Bullet} />
                                </InlineTableCell>
                                <td style={{ verticalAlign: "left", paddingBottom: "1.5rem" }}>
                                    <span>
                                        {t("configure_sso_setting.sso_modal.sso_modal_warning_2")}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <InlineTableCell>
                                    <img src={Bullet} />
                                </InlineTableCell>
                                <td style={{ verticalAlign: "left", paddingBottom: "1.5rem" }}>
                                    <span>
                                        {t("configure_sso_setting.sso_modal.sso_modal_warning_3")}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </InlineTable>
                </Message>

                <ButtonGroup>
                    <SecondaryButton
                        onClick={() => {
                            handleClose();
                            onCancel();
                        }}
                    >
                        <SecondaryText>
                            <p>{t("configure_sso_setting.sso_modal.sso_modal_cancel")}</p>
                        </SecondaryText>
                    </SecondaryButton>
                    <PrimaryButton
                        onClick={() => {
                            handleClose();
                            onConfirm();
                        }}
                    >
                        <PrimaryText>
                            <p>{t("configure_sso_setting.sso_modal.sso_modal_continue")}</p>
                        </PrimaryText>
                    </PrimaryButton>
                </ButtonGroup>
            </ModalContainer>
        </SSOModal>
    );
};
